import React from 'react'
import Marquee from 'react-fast-marquee'
import styled from 'styled-components'

import { colorBlack, colorOrange, colorWhite, colorYellow } from '../../Global/global-styles'
import ResponsiveFont from '../ResponsiveFont/ResponsiveFont'

// A PureComponent
const MessageBanner = React.memo<{
    isError: boolean
    texts?: string[]
}>(({ isError, texts }) => {
    if (!texts) {
        return null
    }

    const message = texts.map((t, i) => <MessageText key={i}>{t}</MessageText>)

    return (
        <ContentContainer $isError={isError}>
            <Marquee speed={100} pauseOnHover>
                <ResponsiveFont ratio={30}>{message}</ResponsiveFont>
            </Marquee>
        </ContentContainer>
    )
})

export default MessageBanner

interface ContentContainerProps {
    $isError: boolean
}
const ContentContainer = styled.div<ContentContainerProps>`
    font-family: NotoSans, sans-serif;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: ${(props: ContentContainerProps) => (props.$isError ? colorOrange : colorYellow)};
    color: ${(props: ContentContainerProps) => (props.$isError ? colorWhite : colorBlack)};
    text-align: center;
    line-height: 1.2;
    z-index: 10;
    font-weight: bold;
    white-space: nowrap;

    @media (orientation: portrait) {
        padding: 1vh 0;
    }

    @media (orientation: landscape) {
        padding: 2vh 0;
    }
`

const MessageText = styled.span`
    display: inline-block;
    margin: 0 20px;
    line-height: 1.3;

    &:after {
        content: '\/\/';
        display: inline-block;
        margin-left: 40px;
        margin-right: 40px;
    }
`
